//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  async fetch () {
    await this.$store.dispatch('proteam/GET_ATHLETES')

    const meta = Array.isArray(this.$route.meta) ? this.$route.meta : [this.$route.meta]

    let athleteId = meta.map(meta => meta.athleteId).pop()
    if (!athleteId) {
      try {
        athleteId = this.$store.getters['proteam/athleteId'](this.$route.params.slug)
      } catch (error) {
        this.$log.error(error, 'Pro Team')
        this.$sentry.captureException(error)
        return this.$redirect('/pro-team')
      }
    }

    if (!athleteId) {
      return this.$redirect('/pro-team')
    }

    await this.$store.dispatch('proteam/GET_ATHLETE_BY_ID', athleteId)
  },
  computed: {
    athleteId () { return this.$route.meta.athleteId || this.$store.getters['proteam/athleteId'](this.$route.params.slug) },
    athlete () { return this.$store.getters['proteam/athlete'](this.athleteId) || {} },
    age () { return this.$moment().diff(this.athlete.dob, 'years') },
    products () { return (this.athlete.wearing || '').split(',') },
    twitterPost () { return (this.athlete.social_posts || []).find(post => post.source === 'twitter') },
    instaPosts () { return (this.athlete.social_posts || []).filter(post => post.source === 'instagram').slice(0, 3) }
  }
}
